var _style, _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyportfoliodesigncopy01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#1A1A1A;}\n\t.st2{fill:#FED631;}\n\t.st3{fill:#FFFFFF;stroke:#1A1A1A;stroke-width:17;stroke-miterlimit:10;}\n\t.st4{fill:#FED631;stroke:#1A1A1A;stroke-width:12;stroke-miterlimit:10;}\n\t.st5{fill:#FED631;stroke:#1A1A1A;stroke-width:4;stroke-miterlimit:10;}\n\t.st6{fill:#1A1A1A;stroke:#1A1A1A;stroke-width:2;stroke-miterlimit:10;}\n\t.st7{fill:#FED631;stroke:#212121;stroke-width:12;stroke-miterlimit:10;}\n\t.st8{fill:#1A1A1A;stroke:#1A1A1A;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M717,174.9c-0.1,60.8,0.2,121.6,0.1,182.5c0,11.4,9.3,20.7,20.7,20.6c52-0.1,104,0.5,156.1,0.1 c-0.4,132.4-0.8,264.7-1.2,397.1c0.2,3.8,1.1,27.6-17.4,46.7c-17.9,18.4-40.6,18.6-44.6,18.6H635.1V569.3 c0-11.1-9-20.1-20.1-20.1c-104.4,0-206.9,0.1-311.5,0c0-137.2,0.1-275.5,0.2-412.6c-0.1-3.9,0-27,18.7-45.2 c18.5-17.9,41.3-17.5,45.2-17.3c153.4,0,306.7,0,460,0c5.9-0.4,26.6-1.1,44.8,13.1c18.8,14.8,27.6,41.9,23.3,67.2 c-52.5,0.6-105.6-0.4-158.3-0.1C726.2,154.3,717.1,163.5,717,174.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1065.1,174.4c0-11.3-9-20.5-20.3-20.7c-43.8-0.6-87.4,2.8-131.3,0.6c0.4-3.8,4.9-47.2-26.4-75.3 c-24.9-22.4-55-20.9-60.8-20.5c-151.7,0-303.4,0-455.1,0c-3.9-0.5-37.6-4.1-63.4,21.9c-25.4,25.5-22.1,58.5-21.6,62.6 c-0.4,135-0.9,271.2-1.3,406.2c-23.2,0.3-47.1-0.1-70.6-0.1c-11,0-20,9-20.1,20c-0.2,133.6,0.3,267.1,0.1,400.7 c0,11.1,9,20.1,20.1,20.1c133.7-0.8,267.3-1.7,400.9-2.5c11,0,19.9-9,19.9-20c0.1-37.8-0.9-75.9-0.2-113.6 c60.8-0.2,123.9,0.2,184.7,0c3.4,0.4,41.6,5.1,68.9-24.3c25.2-27.2,20.6-61.3,19.9-65.6c0.2-129.1,0.4-256.6,0.7-385.7 c45.1-0.6,90.3,0.4,135.4,0.2c11.3,0,20.5-9.3,20.5-20.7C1065.2,298.1,1065,233.9,1065.1,174.4z M594,973.2 c-60-0.9-120-0.3-180.1-0.3c-60,0-120-0.4-180,0.2c-16.2,0.2-23.9-2.8-23.8-21.7c0.7-120.8,0.6-241.6,0.1-362.4 c-0.1-16.8,6-21.2,21.9-21.2c120.8,0.5,241.7,0.6,362.6-0.1c17.9-0.1,22.4,6.1,22.3,23.2c-0.6,119.9-0.6,239.9,0,359.9 C617.1,968.8,611.1,973.5,594,973.2z M895.8,154.4c-52.5,0.6-105.6-0.4-158.3-0.1c-11.4,0-20.5,9.3-20.6,20.6 c-0.1,60.8,0.2,121.6,0.1,182.5c0,11.4,9.3,20.7,20.7,20.6c52-0.1,104,0.5,156.1,0.1c-0.4,132.4-0.8,264.7-1.2,397.1 c0.2,3.8,1.1,27.6-17.4,46.7c-17.9,18.4-40.6,18.6-44.6,18.6H635.1V569.3c0-11.1-9-20.1-20.1-20.1c-104.4,0-206.9,0.1-311.5,0 c0-137.2,0.1-275.5,0.2-412.6c-0.1-3.9,0-27,18.7-45.2c18.5-17.9,41.3-17.5,45.2-17.3c153.4,0,306.7,0,460,0 c5.9-0.4,26.6-1.1,44.8,13.1C891.3,102,900.2,129.1,895.8,154.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M413.9,972.8c-60,0-120-0.4-180,0.3c-16.2,0.2-23.9-2.8-23.8-21.6c0.8-120.8,0.7-241.6,0.1-362.4 c-0.1-16.8,6-21.2,21.8-21.1c120.9,0.5,241.7,0.6,362.6-0.1c17.9-0.1,22.4,6.1,22.3,23.1c-0.6,120-0.7,239.9,0,359.9 c0.1,17.9-5.9,22.6-23,22.3C534,972.3,473.9,972.8,413.9,972.8z M412.5,878.8c62.2,0,111.9-48.3,112.6-109.5 c0.6-56.4-52.5-109.4-110.5-110.2c-61.1-0.9-112.6,49.1-112.9,109.4C301.5,831.1,349.4,878.8,412.5,878.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M887.7,363.7c-44.9,0-89.8-0.7-134.7,0.4c-17.6,0.4-25.3-3.3-24.8-23.1c1.4-49,1-98.1,0.2-147.1 c-0.2-16.7,4.5-23.9,22.5-23.8c93.1,0.6,186.3,0.6,279.4,0c18-0.1,22.8,6.9,22.6,23.6c-0.7,49-0.8,98.1,0,147.1 c0.3,17.2-5.5,23.6-23,23.2C982.6,363.1,935.1,363.7,887.7,363.7z M951.8,268.2c0.8-29-29.2-60.6-58.3-61.5 c-33.2-1-64.1,27.9-64.2,60.2c-0.1,31.6,26.6,59.7,57.9,61C920.7,329.1,950.8,301.3,951.8,268.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M412.5,878.8c-63.1,0-111-47.7-110.8-110.2c0.2-60.3,51.8-110.3,112.9-109.4c58,0.8,111.2,53.8,110.5,110.2 C524.4,830.5,474.7,878.9,412.5,878.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M951.8,268.2c-1,33.2-31.1,61-64.6,59.6c-31.3-1.3-58-29.4-57.9-61c0.1-32.3,30.9-61.2,64.2-60.2 C922.6,207.5,952.6,239.2,951.8,268.2z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 421.9,
    y: 227.5,
    className: "st1",
    width: 303.8,
    height: 23.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.9,
    y: 267.5,
    className: "st1",
    width: 303.8,
    height: 23.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.9,
    y: 307.6,
    className: "st1",
    width: 303.8,
    height: 23.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.9,
    y: 347.7,
    className: "st1",
    width: 303.8,
    height: 23.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 602.7,
    cy: 150.5,
    r: 45.4
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M835.3,1147H364.7c-10.1,0-18.3-8.2-18.3-18.3l0,0c0-10.1,8.2-18.3,18.3-18.3h470.7c10.1,0,18.3,8.2,18.3,18.3 l0,0C853.6,1138.8,845.4,1147,835.3,1147z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M835.3,1147H364.7c-10.1,0-18.3-8.2-18.3-18.3l0,0c0-10.1,8.2-18.3,18.3-18.3h470.7c10.1,0,18.3,8.2,18.3,18.3 l0,0C853.6,1138.8,845.4,1147,835.3,1147z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyportfoliodesigncopy01);
export default __webpack_public_path__ + "static/media/my portfolio design copy-01.8de6367edb6b54a629c4a336aae0e988.svg";
export { ForwardRef as ReactComponent };